import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#5865F2', // Discord blue
    },
    secondary: {
      main: '#2D2D2D', // Dark gray
    },
    background: {
      default: '#36393F', // Discord dark theme background
      paper: '#2F3136', // Discord dark theme paper
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B9BBBE',
    },
  },
  typography: {
    fontFamily: '"Whitney", "Helvetica Neue", Helvetica, Arial, sans-serif',
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2F3136',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
}); 